import * as Yup from 'yup';
import { optionalUrlTest } from '../../utils/sharedSchema.utils';

export const htmlEditorLinkSchema = Yup.object().shape({
  url: Yup.string().label('The link').test(optionalUrlTest).required().default(''),
});
